import { Link } from 'react-router-dom';
import React from 'react';
import { darkTheme, palette } from 'theme';
import styled from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import Container from 'components/Container';
import ContentTypography from 'components/ContentTypography';

import EmailIcon from 'mdi-material-ui/Email';

const BlogHeaderWrapper = styled.header`
  background: ${palette.grey[900]};
  margin: -64px 0 -32px 0;
  padding: 0 0 32px 0;
`;

const BlogHeaderContainer = styled(Container)`
  padding-top: calc(64px + 24px);
`;

const BlogLogo = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 45px;
`;

const BlogHeaderTypography = styled(ContentTypography)`
  max-width: 500px;
  margin: 0 20px;
`;

const LogoImg = styled.img`
  margin-right: 10px;
  width: 45px;
  height: 46px;
`;

const BlogTitle = styled(Typography)`
  white-space: nowrap;
  padding-right: 30px;
  letter-spacing: -0.05em;
`;

const BlogHeader = React.memo(
  ({ logo, title, description, subscribe_link }) => {
    return (
      <MuiThemeProvider theme={darkTheme}>
        <BlogHeaderWrapper>
          <BlogHeaderContainer>
            <Grid container alignItems="center" justify="space-between">
              <Grid item>
                <BlogLogo to="/blog">
                  {logo && logo.url && <LogoImg src={logo.url} />}
                  <BlogTitle variant="h4" component="strong">
                    {title}
                  </BlogTitle>
                </BlogLogo>
              </Grid>
              <Hidden smDown>
                <Grid item xs>
                  <BlogHeaderTypography variant="body1" theme={darkTheme}>
                    {description}
                  </BlogHeaderTypography>
                </Grid>
              </Hidden>
              {subscribe_link && (
                <Grid item xs="auto">
                  <Button
                    color="primary"
                    variant="contained"
                    href={subscribe_link.href}
                    target="_blank"
                  >
                    <EmailIcon />
                    &nbsp; {subscribe_link.title}
                  </Button>
                </Grid>
              )}
            </Grid>
          </BlogHeaderContainer>
        </BlogHeaderWrapper>
      </MuiThemeProvider>
    );
  }
);

export default BlogHeader;
